import script from "./ManageShare.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageShare.vue?vue&type=script&setup=true&lang=js"

import "./ManageShare.vue?vue&type=style&index=0&id=46b99f5e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b99f5e"]])

export default __exports__